import { camelCase } from 'change-case';
import i18n from '@/settings/i18n';

import { User } from '@/types/user';

export type SubscriptionRequest = {
  projectClassId?: number | null;
  adminIds: number[];
  serviceIds: number[];
  startsOn: string;
  users: User[];
  billingContactId?: number;
  contactId?: number;
  billingNote?: string;
};

export type ConfirmedProjectSubscriptionRequest = {
  projectClassId?: number | null;
  adminIds: number[];
  users: User[];
};

export type UpdateSubscriptionError =
  | SubscriptionRequestErrors
  | ConfirmedSubscriptionRequestErrors;

export type SubscriptionRequestErrors = {
  [P in keyof SubscriptionRequest]?: string[] | Record<string, unknown>;
};

export type SubscriptionRequestErrorUser =
  | {
      engagedId: number;
      engagedRequestCode: string;
    }
  | string;

type ConfirmedSubscriptionRequestErrors = {
  enlargementDeadline: string[];
  reductionDeadline: string[];
  maxStudents: string;
  minStudents: string;
};

export const translateApiErrors = (
  apiErrors: SubscriptionRequestErrors,
): SubscriptionRequestErrors => {
  const data = {};
  Object.keys(apiErrors).forEach((key) => {
    const errors = apiErrors[key];

    // Consider only `StartsOn` (others have been verified before api call)
    if (Array.isArray(errors)) {
      data[key] = errors.map((error: any) => {
        if (typeof error === 'object' && 'errorCode' in error) {
          return i18n.t(
            ['ui.error.' + error.errorCode, 'ui.error.error_with_code'],
            {
              errorCode: error.errorCode,
            },
          );
        } else {
          return i18n.t(`ui.subscription.error.${key}.${camelCase(error)}`);
        }
      });
    } else if (typeof errors === 'object' && 'errorCode' in errors) {
      data[key] = i18n.t(
        ['ui.error.' + errors.errorCode, 'ui.error.error_with_code'],
        {
          errorCode: errors.errorCode,
        },
      );
    } else {
      data[key] = i18n.t('ui.error.unknown_error');
    }
  });
  return data;
};
